"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.savedPropertyResultToSavedProperties = exports.transformSaveProperty = void 0;
var searchResponseToResultPage_1 = require("@/transformers/searchResponseToResultPage");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
exports.transformSaveProperty = function (it, imgDomain) {
    var listType = searchResponseToResultPage_1.listTypeIdMap[it.listingTypeId];
    var price = listType === SfilterTypeGroup_1.SfilterType.BUY ? it.salePrice : it.leasePrice * 1000;
    var salePrice = it.salePrice;
    var leasePrice = it.leasePrice;
    var salePricePerSqftGross = it.sellpersqftGross;
    var leasePricePerSqftGross = it.sellpersqftGross;
    var salePricePerSqftSaleable = it.leasepersqftGross;
    var leasePricePerSqftSaleable = it.leasepersqftNet;
    var leasePricePerSqft = leasePricePerSqftSaleable ?
        leasePricePerSqftSaleable : leasePricePerSqftGross;
    var salePricePerSqft = salePricePerSqftSaleable ?
        salePricePerSqftSaleable : salePricePerSqftGross;
    var pricePerSqft = listType === SfilterTypeGroup_1.SfilterType.BUY ? salePricePerSqft : leasePricePerSqft;
    var images = it.propertyPhotos ? it.propertyPhotos
        .filter(function (it) { return it.isPrimary; })
        .map(function (it) { return ({
        path: "" + searchResponseToResultPage_1.toPhotoPath(it.photoName, it.photoType, imgDomain),
        caption: searchResponseToResultPage_1.photoTypeMap[it.photoType.toUpperCase()],
    }); }) : [];
    return {
        price: price,
        salePrice: salePrice,
        leasePrice: leasePrice,
        pricePerSqft: pricePerSqft,
        salePricePerSqft: salePricePerSqft,
        salePricePerSqftGross: salePricePerSqftGross,
        salePricePerSqftSaleable: salePricePerSqftSaleable,
        leasePricePerSqft: leasePricePerSqft,
        leasePricePerSqftGross: leasePricePerSqftGross,
        leasePricePerSqftSaleable: leasePricePerSqftSaleable,
        images: images,
        isSoleAgent: Number(it.isSoleAgent) ? true : false,
        isJointSoleAgent: Number(it.isJointSoleAgent) ? true : false,
        includeManagementFee: searchResponseToResultPage_1.reverseMapLeaseInc(it.leaseInc),
        building: it.buildingName,
        area: it.districtName,
        address: '',
        type: searchResponseToResultPage_1.listTypeIdMap[it.listingTypeId],
        sizeGross: it.grossSize,
        sizeSaleable: it.netSize,
        size: it.netSize ? it.netSize : it.grossSize,
        isSaved: false,
        isSaving: false,
        buildingAge: it.builtYear ? new Date().getFullYear() - Number(it.builtYear) : -1,
        floor: '',
        lastUpdated: new Date(it.lastUpdatedDate),
        referenceId: it.propertyListingId,
        userPropertyId: it.userPropertyId,
        available: true,
        currencyId: it.currencyId,
        isVirtual: it.isVirtual,
        amenities: [],
        createdDate: it.createdDate ? new Date(it.createdDate) : null,
    };
};
exports.savedPropertyResultToSavedProperties = function (result, imgDomain) {
    if (!result || !result.pager || !result.properties || !result.properties.length)
        return [];
    var transformed = result.properties.map(function (it) { return exports.transformSaveProperty(it, imgDomain); });
    return transformed;
};
